module.exports = __webpack_public_path__ + "media/images/locations/austerlia-727f3a268f3933afadbb1582c042965a.jpg";